(async () => {
  const url = new URL(document.location.href);
  url.search = "";

  let baseUrl = (url.href || "").toLowerCase();
  if (!baseUrl.endsWith(".html") && !baseUrl.endsWith("/")) {
    baseUrl = `${baseUrl}/`;
  }
  if (baseUrl.endsWith("/")) {
    for await (const page of ["overview.html", "home.html", "index.html"]) {
      const probableUrl = `${baseUrl}${page}`;
      const result = await fetch(probableUrl, { method: "HEAD" });
      if (result.status < 400) {
        document.location.href = probableUrl;
        break;
      }
    }
  }
})();
